export const SET_HOT_PICKUP_SELECTED_POSTCODE = 'ui/SET_HOT_PICKUP_SELECTED_POSTCODE'
export const SET_HOT_PICKUP_SELECTED_PREFECTURE = 'ui/SET_HOT_PICKUP_SELECTED_PREFECTURE'
export const SET_HOT_PICKUP_SELECTED_CITY = 'ui/SET_HOT_PICKUP_SELECTED_CITY'
export const SET_HOT_DELIVERY_SELECTED_POSTCODE = 'ui/SET_HOT_DELIVERY_SELECTED_POSTCODE'
export const SET_HOT_DELIVERY_SELECTED_PREFECTURE = 'ui/SET_HOT_DELIVERY_SELECTED_PREFECTURE'
export const SET_HOT_DELIVERY_SELECTED_CITY = 'ui/SET_HOT_DELIVERY_SELECTED_CITY'



// WEBPACK FOOTER //
// ./src/vuex/modules/ui/mutation-types.js